import { InjectionToken } from "@angular/core";
import { InHouseOrderService } from "./core/services/inHouseOrder.service";

export const INHOUSEORDER_SERVICE_INJECTION_TOKEN = new InjectionToken<InHouseOrderService>('InHouseOrderService');